class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      var newTotal = data.total_price/100;
      //console.log(newTotal);
      var newTotalTotal = newTotal.toLocaleString();
      //console.log(newTotalTotal);
      var newItemCount = data.item_count;
      //console.log(newItemCount);
      var shippingThreshold = parseInt(document.querySelector("#shipping_threshold").value);

      document.querySelector('.cart-drawer__total').innerHTML = newTotalTotal;   
      document.querySelector('.cart-drawer__items').innerHTML = newItemCount;   
      if (newTotal > shippingThreshold) {
        document.querySelector('.cart-notification-message').innerHTML = 'You qualify for free shipping!';
        document.querySelector('.progress-bar').style.width = '100%';
        document.querySelector('.ship-remain').innerHTML = '<strong>$' + parseFloat(newTotalTotal).toFixed(2) +'</strong>';
      } else {
        var percentage_remain = Math.round((newTotal / shippingThreshold * 100));
        var money_remain = (shippingThreshold - newTotal);
        document.querySelector('.progress-bar').style.width = '' + percentage_remain + '%';
        document.querySelector('.cart-notification-message').innerHTML = '<strong>Add $' + money_remain.toFixed(2) + '</strong> more to qualify for free shipping';
        document.querySelector('.ship-remain').innerHTML = '<strong>$' + parseFloat(newTotalTotal).toFixed(2) +'</strong>';
      }
      var qty = document.querySelector('#Quantity-'+this.productId).value;
      //console.log(this.productId);
      //console.log(qty);
      document.querySelector('.new_qty').innerHTML = qty;            
    }))        
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.productId = parsedState.id;      
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    var dom = new DOMParser()
      .parseFromString(html, 'text/html'),
      elem = dom.querySelector(selector);
    if (elem) {
      return elem.innerHTML;
    } else if (selector.indexOf("cart-notification-product") > 0) {
      selector = selector.split(':')[0].replaceAll('=', '^=');
      elem = dom.querySelector(selector);
      if (elem) {
        return elem.innerHTML;
      }
    }    
    return '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
